import styled from 'styled-components';

export const BaseSection = styled.div`
  min-height: 100vh;
`;

interface IFirstSectionProps {
  $backgroundImage: string;
}
export const FirstSection = styled(BaseSection)<IFirstSectionProps>`
  background-image: url(${props => props.$backgroundImage});
  background-size: cover;
  background-position: center;
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${({ theme }) => theme.white};
  text-align: center;
  padding-top: 6rem;
`;

